/**
 * Common enum dropdown component connected to formik context
 */
import { forwardRef } from 'react';
import { useField } from 'formik';
import { PureEnumDropdown, PureEnumDropdownProps } from './PureEnumDropdown';
import { useFormikFieldErrorAfterSubmit } from '../useFormikFieldErrorAfterSubmit';

export type EnumDropdownProps = Omit<Partial<PureEnumDropdownProps>, 'fieldName'> &
  Required<Pick<PureEnumDropdownProps, 'fieldName'>>;

export const EnumDropdown = forwardRef<HTMLDivElement, EnumDropdownProps>((props, ref) => {
  const { fieldName } = props;
  const [field, , helpers] = useField(fieldName);
  const error = useFormikFieldErrorAfterSubmit(fieldName);

  return (
    <PureEnumDropdown {...props} {...field} error={error} onChange={helpers.setValue} ref={ref} />
  );
});
